<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>The Psalms as Christian Lament</h1>
<h1 class="bk1">A Historical Commentary</h1>
<p class="bkau">Bruce K. Waltke, James M. Houston, and Erika Moore</p>
<p class="bkpub">W<span class="sm">ILLIAM</span> B<span class="sm">.</span> E<span class="sm">ERDMANS</span> P<span class="sm">UBLISHING</span> C<span class="sm">OMPANY</span></p>
<p class="bkpub1">G<span class="sm">RAND</span> R<span class="sm">APIDS,</span> M<span class="sm">ICHIGAN</span> <span class="sm">/</span> C<span class="sm">AMBRIDGE,</span> U<span class="sm">.</span>K<span class="sm">.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-psalmschristian-0003.vue?7f8963c2